import { render } from "./AllCourses.vue?vue&type=template&id=1c1b6f3c&scoped=true"
import script from "./AllCourses.vue?vue&type=script&lang=js"
export * from "./AllCourses.vue?vue&type=script&lang=js"

import "./AllCourses.vue?vue&type=style&index=0&id=1c1b6f3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1b6f3c"]])

export default __exports__